// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"buttonsWrapper__1PuhL","expandCollapseBtn":"expandCollapseBtn__i64IV"};